import {
  Box,
  Flex,
  Spinner,
  useToast,
  Heading,
  Divider,
  Table,
  Tbody,
  Tr,
  Td,
  Text,
} from "@chakra-ui/react";
import React, { Fragment, useState, useEffect, useContext } from "react";
import { useParams } from "react-router-dom";
// import AdditionalDetails from '../../component/AdditionalDetails'
import BillDetails from "../../component/BillDetails";
import Details from "../../component/Details";
import DetailsHeader from "../../component/DetailsHeader";
import RightSidebar from "../../component/RightSidebar";
import Timeline from "../../component/Timeline";

import axios from "axios";
import { Auth } from "../../component/Auth";
import { Context } from "../../component/store";

const OrderDetails = () => {
  const [finalAmountCalObj, setFinalAmountCalObj] = useState({});
  const [orderData, setOrderData] = useState({});
  const [tenureData, setTenureData] = useState(null);
  const [renderOnStatusChange, setRenderOnStatusChange] = useState("");
  const [renderOnDeliveredChange, setRenderOnDeliveredChange] = useState(0);
  const [returnDetails, setReturnDetails] = useState([]);
  const [count, setCount] = useState(0);
  const [billDetailsJson, setBillDetailsJson] = useState({
    subtotal: 0,
    totalTax: 0,
    securityDeposit: 0,
    total: 0,
    shippingFee: 0,
  });

  // const [savePartyDetails, setSavePartyDetails] = useState("")
  const { id } = useParams();
  const toast = useToast();
  const { userData } = useContext(Context);

  let price = 0;
  let orderAmount = "";

  // const [renderMe, setRenderMe] = useState(0)
  // const [publishLoading, setPublishLoading] = useState(false)
  // let statusItems = [
  //   {status: "ORDER_PUBLISHED", title: "Publish"},{status: "ORDER_TRANSIT", title: "In Transit"},{status: "ORDER_DELIVERED", title: "Delivered"},{status: "ORDER_VERIFIED", title: "Verify Order"},
  //   {status: "ORDER_CANCELED", title: "Canceled"},{status: "ORDER_CREATED", title: "Order Created"}, {status: "ORDER_OUT_FOR_DELIVERY", title: "Out for Delivery"}, {status: "ORDER_RETURNED", title: "Return Order"},
  //   {status: "ORDER_PENDING_FOR_FULFILLMENT", title: "Pending for Fulfillment"},{status: "ORDER_READY_FOR_FULFILLMENT", title: "Ready for Fulfillment"}
  // ]
  let statusItems = [
    { status: "ORDER_PUBLISHED", title: "Publish" },
    { status: "ORDER_DELIVERED", title: "Delivered" },
    { status: "ORDER_VERIFIED", title: "Verify Order" },
    { status: "ORDER_CANCELED", title: "Canceled" },
    { status: "ORDER_CREATED", title: "Order Created" },
    { status: "ORDER_OUT_FOR_DELIVERY", title: "Out for Delivery" },
    { status: "AWAITING_VERIFICATION", title: "Awaiting for Verification" },
    { status: "TERMINATED", title: "Terminate Order" },
    { status: "COMPLETED", title: "Completed" },
    { status: "EARLY_CLOSURE", title: "Early Closure" },
  ];

  let tempTenureSeqId = [];
  // let returnItemDetails = []

  // const menuStyle = {
  //   fontSize: '12',
  //   fontWeight: '400',
  //   letterSpacing: '0.1',
  //   _first: {
  //     bgColor: 'transparent'
  //   },
  //   _hover: {
  //     bgColor: 'rgba(67, 138, 254, 0.1)',
  //   }
  // }
  // const menuButton = {
  //   px: '16px',
  //   py: '0',
  //   h: '36px',
  //   w: '203px',
  //   bgColor: '#FFFFFF',
  //   _hover: {bgColor: 'rgba(67, 138, 254, 0.1)'},
  //   color: '#438AFE',
  //   border: '1px solid #438AFE'

  // }

  // Shipping Address change/update render
  const addressChangeRender = () => {
    setCount((prev) => prev + 1);
  };

  // status change function render
  const handleChildStateChange = (newState) => {
    setRenderOnStatusChange(newState);
  };
  // on delevered status success
  const deliveredRender = () => {
    setRenderOnDeliveredChange((prev) => renderOnDeliveredChange + 1);
  };
  // Publish Handler
  // const publishHandler = () => {
  //   setPublishLoading(true)
  //   let data = JSON.stringify({
  //     "orderId": `${id}`,
  //     "reqType": "POST"
  //   });

  //   let config = {
  //     method: 'post',
  //     maxBodyLength: Infinity,
  //     url: `${process.env.REACT_APP_RALCO_API_URL}/api/order/shopify/sync-draft-order`,
  //     headers: {
  //       'Content-Type': 'application/json',
  //       'Authorization': Auth()
  //     },
  //     data : data
  //   };

  //   axios.request(config)
  //   .then((response) => {
  //     setPublishLoading(false)
  //     setRenderMe((prev) => renderMe + 1)
  //     toast({
  //       title: `Order Successfully Published`,
  //       position: 'top',
  //       status: 'success',
  //       duration: 4000,
  //       isClosable: true,
  //     })

  //   })
  //   .catch((error) => {
  //     console.log(error);
  //     setPublishLoading(false)
  //     toast({
  //       title: `Something went wrong try again`,
  //       position: 'top',
  //       status: 'error',
  //       duration: 4000,
  //       isClosable: true,
  //     })

  //   });
  // }

  // get order by id
  useEffect(() => {
    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_RALCO_API_URL}/api/order/${id}`,
      headers: {
        Authorization: Auth(),
      },
    };
    axios
      .request(config)
      .then((response) => {
        setOrderData(response.data);
        // fetching all tenure details ------------
        let data = JSON.stringify({
          orderId: response.data?.OrderItem[0]?.orderId,
        });

        let config = {
          method: "post",
          maxBodyLength: Infinity,
          url: `${process.env.REACT_APP_RALCO_API_URL}/api/tenure/get-tenure-list`,
          headers: {
            "Content-Type": "application/json",
            Authorization: Auth(),
          },
          data: data,
        };

        axios
          .request(config)
          .then((response) => {
            setTenureData(response.data);
            if (response.data.length === 0) {
              toast({
                title: `Tenure data not found`,
                position: "top",
                status: "warning",
                duration: 5000,
                isClosable: true,
              });
            }
          })
          .catch((error) => {
            console.log(error);
          });
      })
      .catch((error) => {
        console.log(error);
      });
  }, [id, toast, renderOnStatusChange, renderOnDeliveredChange, count]);

  // Format Date ----
  const formatDate = (date) => {
    const options = {
      year: "2-digit",
      month: "short",
      day: "numeric",
    };
    const dateString = date.toLocaleDateString("en-US", options);
    const timeString = date.toLocaleTimeString("en-US", {
      hour: "numeric",
      minute: "numeric",
      hour12: true,
    });
    return `${dateString}, ${timeString}`;
  };

  // Order status flow -------
  // order status ka flow kuch iss tarah h :-
  //   1.Order Create
  //   2.Order Verified
  //   3.Pending fulfillment
  //   4.Ready for fufilllment
  //   5.Order picked
  //   6.Order in transit
  //   7.Order out for delivery
  //   8.Order delivered / fulfilled

  const user = userData;
  switch (orderData?.orderStatusId) {
    case "ORDER_DRAFT":
      statusItems = statusItems.filter(
        (d) => d.status === "ORDER_PUBLISHED" || d.status === "ORDER_CANCELED"
      );
      break;
    case "AWAITING_VERIFICATION":
      statusItems = statusItems.filter(
        (d) => d.status === "ORDER_VERIFIED" || d.status === "ORDER_CANCELED"
      );
      break;
    case "ORDER_OUT_FOR_DELIVERY":
      statusItems = statusItems.filter(
        (d) => d.status === "ORDER_DELIVERED" || d.status === "ORDER_CANCELED"
      );
      break;
    case "ORDER_VERIFIED":
      statusItems = statusItems.filter(
        (d) =>
          d.status === "ORDER_OUT_FOR_DELIVERY" || d.status === "ORDER_CANCELED"
      );
      break;
    case "ORDER_DELIVERED":
      statusItems = statusItems.filter(
        (d) =>
          d.status === "TERMINATED" ||
          d.status == "COMPLETED" ||
          d.status == "EARLY_CLOSURE"
      );
      break;
    case "ORDER_CREATED":
      if (user.userGroupMember.includes("ADMIN")) {
        statusItems = statusItems.filter(
          (d) => d.status === "ORDER_VERIFIED" || d.status === "ORDER_CANCELED"
        );
      } else {
        statusItems = [];
      }
      break;
    case "ORDER_PUBLISHED":
      statusItems = [];
      break;
    case "TERMINATED":
      statusItems = [];
      break;
    case "ORDER_CANCELED":
      statusItems = [];
      break;
    case "ACTIVE":
      statusItems = statusItems.filter(
        (d) =>
          d.status === "EARLY_CLOSURE" ||
          d.status === "TERMINATED" ||
          d.status == "COMPLETED"
      );
      break;
    case "PAYMENT_PENDING":
      statusItems = statusItems.filter((d) => d.status === "TERMINATED" || d.status == "EARLY_CLOSURE");
      break;
    case "ENDING_TOMORROW":
      statusItems = statusItems.filter((d) => d.status === "COMPLETED");
      break;
    case "ENDED":
      statusItems = statusItems.filter((d) => d.status === "COMPLETED");
      break;
    default:
      statusItems = [];
  }

  // ---- set price for price input value ---
  // Total Item Price Caluculation
  const endDateCalculation = (date, duration, typeOfTenure) => {
    // Define the start date and duration
    const startDate = new Date(date);
    const durationDays =
      typeOfTenure === "weekly" ? duration * 7 : duration * 30;
    // Weekly Calculation Condition - if block
    if (typeOfTenure === "weekly" && duration > 0) {
      // Calculate the end date of week
      let endDate = new Date(
        startDate.getTime() + (durationDays - 1) * 24 * 60 * 60 * 1000
      );
      const endDateObj = new Date(endDate);
      endDate = `${endDateObj.getDate()}/${endDateObj.toLocaleString(
        "default",
        { month: "short" }
      )}/${endDateObj.getFullYear()}`;
      // Weekly days * amount
      orderAmount = calculateNoOfDays(endDate, startDate);
      return endDate;
      // Monthly Calculation Condition - else block
    } else if (typeOfTenure === "monthly" && duration > 0) {
      // Calculate the end date of month
      let endDate = new Date(
        startDate.getTime() + durationDays * 24 * 60 * 60 * 1000
      );

      // Set the end date to the last day of the month
      endDate.setMonth(endDate.getMonth());
      endDate.setDate(0);

      // Format the end date
      const endDateMonth = `${endDate.getDate()}/${endDate.toLocaleString(
        "default",
        {
          month: "short",
        }
      )}/${endDate.getFullYear()}`;
      orderAmount = remainingDaysInMonth(new Date(date));
      return endDateMonth;
    } else {
      return;
    }
  };

  const calculatBillDetailsJson = () => {
    if (!orderData || !tenureData) return;
    let totalPrice = 0;
    let totalRefundableDeposit = 0;

    orderData.OrderItem.forEach((orderItem) => {
      const tenureItem = tenureData.find(
        (tenure) => tenure.orderItemSeqId === orderItem.orderItemSeqId
      );

      let price = 0;
      if (tenureItem.tenure.tenurePeriodId === "WEEKLY") {
        price = parseFloat(tenureItem.pricePerWeek) * tenureItem.weeks;
      } else {
        price = parseFloat(tenureItem.pricePerMonth);
      }

      const refundableDeposit = parseFloat(orderItem.refundableDeposit);

      totalPrice += price;
      totalRefundableDeposit += refundableDeposit;
      console.log(price, refundableDeposit, "price and refundable deposit");
    });

    const totalTax = (totalPrice + parseFloat(orderData?.shippingFee)) * 0.18;
    const total =
      totalPrice +
      totalTax +
      totalRefundableDeposit +
      parseFloat(orderData?.shippingFee);
    setBillDetailsJson({
      subtotal: totalPrice,
      totalTax: totalTax,
      securityDeposit: totalRefundableDeposit,
      total: total,
      shippingFee: orderData?.shippingFee,
    });

    console.log(billDetailsJson, "bill details json");
  };

  useEffect(() => {
    calculatBillDetailsJson();
  }, [orderData, tenureData]);

  // Calculate the number of days in weekly
  const calculateNoOfDays = (endDate, startDate) => {
    const timeDiff =
      new Date(endDate).getTime() - new Date(startDate).getTime();
    const diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
    return (diffDays + 1) * price;
  };
  // Calculate the number of remaining days in month
  const remainingDaysInMonth = (date) => {
    const year = date.getFullYear();
    // const month = date.getMonth() + 1;
    const month = date.getMonth() + 1;
    const day = date.getDate();
    const numDaysInMonth = new Date(year, month, 0).getDate();
    let remainingDays = numDaysInMonth - day;
    // console.log(remainingDays + 1, '55555555555555555555')
    remainingDays += 1;
    return remainingDays * price;
  };

  // #### TO CHECK RETURN CREATED OR NOT ####
  useEffect(() => {
    let data = "";
    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_RALCO_API_URL}/api/return-order?orderId=${id}`,
      headers: {
        "Content-Type": "application/json",
        Authorization: Auth(),
      },
      data: data,
    };

    axios
      .request(config)
      .then((response) => {
        console.log(response.data, "return data here");
        setReturnDetails(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [renderOnStatusChange]);

  console.log(
    returnDetails
      ?.map((x) =>
        x.ReturnItem.filter(
          (y) => y.statusId === "RETURN_CREATED" && y.orderItemSeqId === 23
        )
      )
      .some((n) => n.length > 0),
    "00000000000000000"
  );

  const currencyFormat = (amount) => {
    return `₹ ${amount.toLocaleString("en-IN", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })}`;
  };

  console.log(orderData, 'order data here')

  return (
    <Fragment>
      {Object.keys(orderData).length > 0 && tenureData !== null ? (
        <Box width={"80%"}>
          <Flex p={5} pb={0}>
            <Box flexBasis={"100%"}>
              <DetailsHeader
                title={"Order"}
                colorScheme={"blackAlpha"}
                variant={"solid"}
                invoice={"Create"}
                menuItems={statusItems}
                changeStatusId={null}
                orderName={
                  orderData?.OrderName.includes("#")
                    ? orderData?.OrderName
                    : "Draft"
                }
                handleChildStateChange={handleChildStateChange}
                deliveredRender={deliveredRender}
                orderData={orderData}
                tenureData={tenureData}
                // partyDetails={savePartyDetails}
                mobile={orderData.customerParty?.phone}
              />
            </Box>
            {/* <Flex flexBasis={'30%'} justifyContent={'end'}>
              {orderData.orderStatusId === 'ORDER_DRAFT' && orderData?.OrderItem.length > 0 &&
               <Tooltip hasArrow label='Publish order'>
              <Button isLoading={publishLoading} loadingText='Loading' colorScheme='red' marginRight={3} onClick={publishHandler}>Publish</Button>
              </Tooltip>
              }
            </Flex> */}
            {/* <Flex flexBasis={'30%'} justifyContent={'end'}>
              <Menu width={200} >
                <MenuButton rightIcon={<AiOutlineDown />} as={Button} sx={menuButton} rounded={'lg'}>
                  Assign for Delivery
                </MenuButton>
                <MenuList h={{ base: `${window.innerHeight - 150}px`, md: `${window.innerHeight - 150}px`, lg: `${window.innerHeight - 150}px`, xl: `${window.innerHeight - 150}px`, '2xl': 'auto' }} overflowY={'scroll'}>
                  {["Aditya Sharma","Aditya Sharma","Aditya Sharma","Aditya Sharma","Aditya Sharma","Deepak Sharma","Gagan Verma"]?.map((e, i) => {
                    return (
                      <MenuItem key={i} sx={menuStyle}>{e}</MenuItem>
                    )
                  })}
                </MenuList>
              </Menu>
            </Flex>*/}
          </Flex>
          <Flex justifyContent={"space-evenly"}>
            <Box p={5} pt={0} w={"70%"} bgColor="#F5F5F5">
              {orderData?.OrderItem?.map((d, i) => {
                tempTenureSeqId = tenureData.filter(
                  (x) => x.orderItemSeqId === d.orderItemSeqId
                );
                {
                  /* returnItemDetails = returnDetails.map((x) => x.filter((y) => (y.statusId === "RETURN_CREATED" && y.orderItemSeqId === d.orderItemSeqId))) */
                }

                price = d.unitPrice;
                endDateCalculation(
                  tenureData[0]?.tenure?.startDate,
                  tempTenureSeqId[0]?.tenure?.tenurePeriodId === "MONTHLY"
                    ? tempTenureSeqId[0]?.months
                    : tempTenureSeqId[0]?.weeks,
                  tempTenureSeqId[0]?.tenure?.tenurePeriodId.toLowerCase()
                );
                if (i === 0) {
                  window.sessionStorage.setItem(
                    "invoiceTotalCal",
                    JSON.stringify({
                      totalItemPrice: [],
                      totalDiscount: [],
                      totalTax: [],
                      totalDeposit: [],
                      netPayable: 0,
                    })
                  );

                  window.sessionStorage.setItem(
                    "invoiceTotalFinal",
                    JSON.stringify({
                      totalItemPrice: 0,
                      totalDiscount: 0,
                      totalTax: 0,
                      totalDeposit: 0,
                      subTotal: 0,
                      netPayable: 0,
                    })
                  );
                }
                // Settting total
                const totalObj = JSON.parse(
                  sessionStorage.getItem("invoiceTotalCal")
                );
                totalObj.totalItemPrice.push(Number(orderAmount));
                totalObj.totalDiscount.push(Number(d.discount));
                totalObj.totalDeposit.push(Number(d.refundableDeposit));
                sessionStorage.setItem(
                  "invoiceTotalCal",
                  JSON.stringify(totalObj)
                );
                // final Calculation
                const calObj = JSON.parse(
                  sessionStorage.getItem("invoiceTotalCal")
                );
                const finalCalucalation = JSON.parse(
                  sessionStorage.getItem("invoiceTotalFinal")
                );
                finalCalucalation.totalItemPrice = calObj.totalItemPrice.reduce(
                  (acc, curr) => parseFloat(curr) + acc,
                  0
                );
                finalCalucalation.totalDiscount = calObj.totalDiscount.reduce(
                  (acc, curr) => parseFloat(curr) + acc,
                  0
                );
                finalCalucalation.totalDeposit = calObj.totalDeposit.reduce(
                  (acc, curr) => parseFloat(curr) + acc,
                  0
                );
                finalCalucalation.subTotal =
                  finalCalucalation.totalItemPrice -
                  finalCalucalation.totalDiscount;
                finalCalucalation.totalTax = finalCalucalation.subTotal * 0.18;
                sessionStorage.setItem(
                  "invoiceTotalFinal",
                  JSON.stringify(finalCalucalation)
                );

                if (
                  i === orderData?.OrderItem.length - 1 &&
                  Object.keys(finalAmountCalObj).length === 0
                ) {
                  setFinalAmountCalObj(
                    JSON.parse(sessionStorage.getItem("invoiceTotalFinal"))
                  );
                }

                return (
                  <Details
                    key={i}
                    orderDetails={{
                      title: d.title,
                      variant: d.variant,
                      rlNumber: d.rlNumber,
                      img: d.productImg,
                      quantity: d.quantity,
                      orderItemSeqId: d.orderItemSeqId,
                      selectedGamesType: d?.selectedGamesType || "n/a",
                      productGeneration: d?.productGeneration || "n/a",
                      productProcessor: d?.productProcessor || "n/a",
                      productOperatingSystem:
                        d?.productOperatingSystem || "n/a",
                    }}
                    orderData={orderData}
                    title={"Order"}
                    order={"Order Placed"}
                    tenureType={
                      tempTenureSeqId[0]?.tenure?.tenurePeriodId
                        .charAt(0)
                        .toUpperCase() +
                        tempTenureSeqId[0]?.tenure?.tenurePeriodId
                          .slice(1)
                          .toLowerCase() +
                        (tempTenureSeqId[0]?.tenure?.tenurePeriodId === "WEEKLY"
                          ? ""
                          : " Tenure") || null
                    }
                    tenureTypeTotal={
                      tempTenureSeqId[0]?.tenure?.tenurePeriodId === "WEEKLY"
                        ? "₹" +
                          Number(
                            tempTenureSeqId[0]?.pricePerWeek
                          ).toLocaleString("en-IN", {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          }) +
                          "/Week"
                        : "₹" +
                          Number(
                            tempTenureSeqId[0]?.pricePerMonth
                          ).toLocaleString("en-IN", {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          }) +
                          "/Month"
                    }
                    // rent
                    rent={
                      "₹" +
                      Number(
                        Number(
                          tempTenureSeqId[0]?.tenure?.tenurePeriodId ===
                            "MONTHLY"
                            ? tempTenureSeqId[0]?.pricePerMonth
                            : tempTenureSeqId[0]?.pricePerWeek
                        ) *
                          (tempTenureSeqId[0]?.tenure?.tenurePeriodId ===
                          "MONTHLY"
                            ? tempTenureSeqId[0]?.months
                            : tempTenureSeqId[0]?.weeks)
                      ).toLocaleString("en-IN", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })
                    }
                    btnColorScheme={
                      d.statusId !== "ORDER_RETURNED"
                        ? (orderData?.orderStatusId === "ORDER_CREATED" &&
                            "green") ||
                          (orderData?.orderStatusId === "ORDER_PUBLISHED" &&
                            "facebook") ||
                          (orderData?.orderStatusId === "ORDER_DRAFT" &&
                            "purple") ||
                          (orderData?.orderStatusId === "ORDER_VERIFIED" &&
                            "whatsapp") ||
                          (orderData?.orderStatusId === "ORDER_DELIVERED" &&
                            "yellow") ||
                          (orderData?.orderStatusId === "TERMINATED" &&
                            "blackAlpha") ||
                          (orderData?.orderStatusId === "COMPLETED" &&
                            "blackAlpha") ||
                          (orderData?.orderStatusId === "ORDER_CANCELED" &&
                            "red") ||
                          (orderData?.orderStatusId ===
                            "ORDER_OUT_FOR_DELIVERY" &&
                            "orange") ||
                          (orderData?.orderStatusId === "ORDER_TRANSIT" &&
                            "messenger") ||
                          (orderData?.orderStatusId === "ORDER_RETURNED" &&
                            "telegram") ||
                          (orderData?.orderStatusId ===
                            "ORDER_PENDING_FOR_FULFILLMENT" &&
                            "teal") ||
                          (orderData?.orderStatusId === "ACTIVE" &&
                            "whatsapp") ||
                            (["ENDED", "ENDING_TOMORROW"].includes(orderData?.orderStatusId)  &&
                            "yellow") ||
                          (orderData?.orderStatusId === "PAYMENT_PENDING" &&
                            "red") ||
                          (orderData?.orderStatusId ===
                            "ORDER_READY_FOR_FULFILLMENT" &&
                            "linkedin") ||
                          (orderData?.orderStatusId === "ORDER_PICKED" &&
                            "pink") ||
                          (orderData?.orderStatusId === "EARLY_CLOSURE" &&
                            "blackAlpha") ||
                          (orderData?.orderStatusId ===
                            "AWAITING_VERIFICATION" &&
                            "cyan")
                        : d.statusId === "ORDER_RETURNED" && "purple"
                    }
                    btnText={
                      d.statusId !== "ORDER_RETURNED"
                        ? orderData?.orderStatusId
                        : d.statusId
                    }
                    orderDate={formatDate(new Date(orderData?.placedDate))}
                    productName={"Product Name"}
                    // productBtnText={"Assign for Delivery"}
                    // productBtnItems={["Aditya Sharma","Aditya Sharma","Aditya Sharma","Aditya Sharma","Aditya Sharma","Deepak Sharma","Gagan Verma"]}
                    row1={[
                      {
                        "Order Date": formatDate(
                          new Date(orderData.placedDate)
                        ),
                      },
                      {
                        "Order GST No.":
                          orderData?.orderGstNumber.length === 0
                            ? "n/a"
                            : orderData?.orderGstNumber,
                      },
                      {
                        "Delivery Date": new Date(
                          tenureData[0]?.tenure?.startDate
                        ).toLocaleDateString("en-IN"),
                      },
                      {
                        "Delivery Location":
                          orderData?.shippingAddress?.city || "----",
                      },
                    ]}
                    row2={
                      [
                        // { "Tenure ID": '#' + tempTenureSeqId[0]?.tenureId.split('-')[4] },
                        // // {[tempTenureSeqId[0]?.tenure?.tenurePeriodId === "WEEKLY" ? "Start Date" : "Tenure Start Date"]: tempTenureSeqId[0]?.tenure?.tenurePeriodId === "WEEKLY" ? new Date(tempTenureSeqId[0]?.tenure?.startDate).toLocaleDateString('en-IN') : new Date(startDateCal((tempTenureSeqId[0]?.tenure?.startDate).split("T")[0])).toLocaleDateString('en-IN')},
                        // { [tempTenureSeqId[0]?.tenure?.tenurePeriodId === "WEEKLY" ? "Start Date" : "Tenure Start Date"]: new Date((tenureData[0]?.tenure?.startDate)).toLocaleDateString('en-IN') },
                        // { [tempTenureSeqId[0]?.tenure?.tenurePeriodId === "WEEKLY" ? "End Date" : "Tenure End Date"]: new Date(tempTenureSeqId[0]?.tenure?.endDate).toLocaleDateString('en-IN') },
                        // { [tempTenureSeqId[0]?.tenure?.tenurePeriodId === "WEEKLY" ? "Period" : "Tenure Period"]: `${tempTenureSeqId[0]?.tenure?.tenurePeriodId === "MONTHLY" ? tempTenureSeqId[0]?.months : tempTenureSeqId[0]?.weeks} ${tempTenureSeqId[0]?.tenure?.tenurePeriodId === "MONTHLY" ? tempTenureSeqId[0]?.months === 1 ? "Month" : "Months" : tempTenureSeqId[0]?.weeks === 1 ? "Week" : "Weeks"}` }
                      ]
                    }
                    status={"Order Draft"}
                    tenureLength={tenureData.length}
                    tenureId={tempTenureSeqId[0]?.tenureId}
                    orderId={id}
                    tenureTableId={d.orderItemSeqId}
                    title2={"Main Order"}
                    returnData={
                      returnDetails
                        ?.filter(
                          (x) =>
                            x.ReturnItem[0].orderItemSeqId === d.orderItemSeqId
                        )
                        .slice(-1)[0] || false
                    }
                    renderOnReturnChange={handleChildStateChange}
                  />
                );
              })}
              <Box
                bgColor={"#FFFFFF"}
                shadow={"md"}
                rounded={"md"}
                border={"1px"}
                borderColor={"gray.200"}
                my={5}
                p={3}
              >
                <Heading size={"md"} mb={2}>
                  Bill Details
                </Heading>
                <Divider size={1} my={2} borderBottomColor={"black"} />
                <Table>
                  <Tbody>
                    <Tr>
                      <Td
                        _first={{ paddingLeft: "0px" }}
                        fontSize={"medium"}
                        fontWeight={"semibold"}
                      >
                        SubTotal
                      </Td>
                      <Td fontSize={"medium"} fontWeight={"semibold"}></Td>
                      <Td
                        fontSize={"medium"}
                        textAlign={"right"}
                        fontWeight={"semibold"}
                      >
                        {currencyFormat(billDetailsJson.subtotal)}
                      </Td>
                    </Tr>
                    <Tr>
                      <Td
                        _first={{ paddingLeft: "0px" }}
                        fontSize={"medium"}
                        fontWeight={"semibold"}
                      >
                        Shipping Fee
                      </Td>
                      <Td fontSize={"medium"} fontWeight={"semibold"}></Td>
                      <Td
                        fontSize={"medium"}
                        textAlign={"right"}
                        fontWeight={"semibold"}
                      >
                        {currencyFormat(billDetailsJson?.shippingFee)}
                      </Td>
                    </Tr>
                    <Tr>
                      <Td
                        _first={{ paddingLeft: "0px" }}
                        fontSize={"medium"}
                        fontWeight={"semibold"}
                      >
                        Total Tax
                      </Td>
                      <Td fontSize={"medium"} fontWeight={"semibold"}>
                        {" "}
                        18% GST{" "}
                      </Td>
                      <Td
                        fontSize={"medium"}
                        textAlign={"right"}
                        fontWeight={"semibold"}
                      >
                        {currencyFormat(billDetailsJson.totalTax)}
                      </Td>
                    </Tr>
                    <Tr>
                      <Td
                        _first={{ paddingLeft: "0px" }}
                        fontSize={"medium"}
                        fontWeight={"semibold"}
                      >
                        Total security deposit
                      </Td>
                      <Td fontSize={"medium"} fontWeight={"semibold"}></Td>
                      <Td
                        fontSize={"medium"}
                        textAlign={"right"}
                        fontWeight={"semibold"}
                      >
                        {currencyFormat(billDetailsJson.securityDeposit)}
                      </Td>
                    </Tr>

                    <Tr>
                      <Td
                        _first={{ paddingLeft: "0px" }}
                        fontSize={"medium"}
                        fontWeight={"bold"}
                      >
                        Total
                      </Td>
                      <Td></Td>
                      <Td textAlign={"right"}>
                        <Text as="span" fontWeight={"bold"}>
                          {currencyFormat(billDetailsJson.total)}
                        </Text>
                      </Td>
                    </Tr>
                    {/* <Tr py={2}>
                            <Td _first={{paddingLeft: '0px'}} fontSize={'medium'} fontWeight={'bold'}>Paid by Customer</Td>
                            <Td></Td>
                            <Td textAlign={'right'}>&#8377; <Text as="span" fontWeight={'extrabold'}>{paid}</Text></Td>
                        </Tr> */}
                  </Tbody>
                </Table>
              </Box>
              {/* <BillDetails
                bills={[
                  {
                    "Base Price": [
                      "",
                      "₹" +
                        finalAmountCalObj?.totalItemPrice?.toLocaleString(
                          "en-IN",
                          {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          }
                        ),
                    ],
                  },
                  {
                    "Tenure Discount": [
                      "",
                      "₹" +
                        finalAmountCalObj?.totalDiscount?.toLocaleString(
                          "en-IN",
                          {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          }
                        ),
                    ],
                  },

                  {
                    Subtotal: [
                      "",
                      "₹" +
                        finalAmountCalObj?.subTotal?.toLocaleString("en-IN", {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        }),
                    ],
                  },
                  {
                    "Total Tax": [
                      "18% GST",
                      "₹" +
                        finalAmountCalObj?.totalTax?.toLocaleString("en-IN", {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        }),
                    ],
                  },
                  {
                    "Total Security Deposite": [
                      "",
                      "₹" +
                        finalAmountCalObj?.totalDeposit?.toLocaleString(
                          "en-IN",
                          {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          }
                        ),
                    ],
                  },
                ]}
                total={(
                  finalAmountCalObj?.totalDeposit +
                  finalAmountCalObj?.subTotal +
                  finalAmountCalObj?.totalTax
                )?.toLocaleString("en-IN", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
                paid={null}
              /> */}
              {orderData?.orderStatusId !== "ORDER_DRAFT" && (
                <Timeline
                  text={"Only you and other admin members can see comments"}
                  orderData={orderData}
                  tenureData={tenureData}
                  orderName={
                    orderData?.OrderName.includes("#")
                      ? orderData?.OrderName
                      : "pending"
                  }
                />
              )}
            </Box>
            <Box pr={3} py={3} mt={6} w={"30%"} bgColor="#F5F5F5">
              <RightSidebar
                customerName={
                  orderData.customerParty?.firstName +
                  " " +
                  orderData.customerParty?.lastName
                }
                customerGmail={orderData.customerParty?.email}
                customerPhone={orderData.customerParty?.phone}
                shippingArea={orderData.shippingAddress}
                shippingCity={orderData.shippingAddress?.city}
                billingAddress={orderData.billingAddress}
                title={"Order"}
                title2={"Order Main"}
                partyId={orderData.customerPartyId}
                addressChangeRender={addressChangeRender}
                addressId={{
                  billingId: orderData?.billingAddressId,
                  shippingId: orderData?.shippingAddressId,
                }}

                orderData={orderData}
                party={orderData.customerParty}
              />
            </Box>
          </Flex>
        </Box>
      ) : (
        <Flex w={"80%"} justifyContent={"center"} mt={8}>
          <Spinner
            thickness="4px"
            speed="0.65s"
            emptyColor="gray.200"
            color="blue.500"
            size="xl"
          />
        </Flex>
      )}
    </Fragment>
  );
};

export default OrderDetails;
